export function bindProductImageZoomToggleChange(toggleEl: HTMLInputElement, onChange: () => void): void {
    toggleEl.addEventListener("change", onChange);
}

export function bindProductImageZoomViewportResize(onResize: () => void): void {
    globalThis.addEventListener("resize", onResize, { passive: true });
}

export function bindAppDomReady(onReady: () => void): void {
    document.addEventListener("DOMContentLoaded", onReady);
}
